import type { IconNode } from '../types';

/**
 * @name virus
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTQuOTkxaC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMjJ2LTMiIC8+CiAgPHBhdGggZD0iTTEyIDJ2MyIgLz4KICA8cGF0aCBkPSJNMTMgMjJoLTIiIC8+CiAgPHBhdGggZD0iTTEzIDJoLTIiIC8+CiAgPHBhdGggZD0iTTEzLjk5IDEwSDE0IiAvPgogIDxwYXRoIGQ9Im0xNi41IDE5Ljc5NC0xLTEuNzMzIiAvPgogIDxwYXRoIGQ9Im0xNi41IDQuMjA1LTEgMS43MzIiIC8+CiAgPHBhdGggZD0ibTE5Ljc5NCAxNi41LTEuNzMyLTEiIC8+CiAgPHBhdGggZD0ibTE5Ljc5NCA3LjUtMS43MzIgMSIgLz4KICA8cGF0aCBkPSJNMiAxMmgzIiAvPgogIDxwYXRoIGQ9Ik0yIDEzdi0yIiAvPgogIDxwYXRoIGQ9Ik0yMiAxMmgtMyIgLz4KICA8cGF0aCBkPSJNMjIgMTN2LTIiIC8+CiAgPHBhdGggZD0ibTQuMjA2IDE2LjUgMS43MzItMSIgLz4KICA8cGF0aCBkPSJtNC4yMDYgNy41IDEuNzMyIDEiIC8+CiAgPHBhdGggZD0ibTcuNSAxOS43OTQgMS0xLjczMyIgLz4KICA8cGF0aCBkPSJtNy41IDQuMjA1IDEgMS43MzIiIC8+CiAgPHBhdGggZD0iTTkgMTJoLjAxIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/virus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Virus: IconNode = [
  ['path', { d: 'M12 14.991h.01' }],
  ['path', { d: 'M12 22v-3' }],
  ['path', { d: 'M12 2v3' }],
  ['path', { d: 'M13 22h-2' }],
  ['path', { d: 'M13 2h-2' }],
  ['path', { d: 'M13.99 10H14' }],
  ['path', { d: 'm16.5 19.794-1-1.733' }],
  ['path', { d: 'm16.5 4.205-1 1.732' }],
  ['path', { d: 'm19.794 16.5-1.732-1' }],
  ['path', { d: 'm19.794 7.5-1.732 1' }],
  ['path', { d: 'M2 12h3' }],
  ['path', { d: 'M2 13v-2' }],
  ['path', { d: 'M22 12h-3' }],
  ['path', { d: 'M22 13v-2' }],
  ['path', { d: 'm4.206 16.5 1.732-1' }],
  ['path', { d: 'm4.206 7.5 1.732 1' }],
  ['path', { d: 'm7.5 19.794 1-1.733' }],
  ['path', { d: 'm7.5 4.205 1 1.732' }],
  ['path', { d: 'M9 12h.01' }],
  ['circle', { cx: '12', cy: '12', r: '7' }],
];

export default Virus;
